module.exports = __webpack_public_path__ + "img/mmi-about-photo-team-jan.45083122.png";